import { language } from '../utils/language';
import convertArrToObj from '../utils/convertArrToObj';

export const FEMALE = 'FEMALE';
export const MALE = 'MALE';
export const OTHER = 'OTHER';

export const GENDERS = [
  {
    id: MALE,
    name: language.label.male,
  },
  {
    id: FEMALE,
    name: language.label.female,
  },
  {
    id: OTHER,
    name: language.label.other,
  },
];

export const GENDER_BY_ID = convertArrToObj(GENDERS, 'id');
